<template>
  <v-container fill-height fluid class="container">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="6" class="text-center">
        <v-overlay
          absolute
          color="#ffffff"
          :opacity="1"
          :value="loader"
        >
          <v-progress-circular :size="70" :width="9" color="primary" light indeterminate transition="fade-transition"></v-progress-circular>
        </v-overlay>

        <v-card class="mx-auto mt-n12" style="width: 90%" tile flat v-if="registrationStatus === false">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Attenzione</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>
           <div class="primary--text text-h4">Qualcosa è andato storto</div>
          </v-card-text>
        </v-card>
        <v-card class="mx-auto mt-n12" style="width: 90%" tile flat v-if="registrationStatus === true">
          <v-list-item>
            <v-list-item-content>
               <div class="primary--text text-h4">Successo</div>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>
            Grazie per il tuo contributo
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import apiService from '@/services'

export default {
  created () {
    this.validateMail()
  },
  data () {
    return {
      registrationStatus: undefined,
      loader: true
    }
  },
  methods: {
    validateMail () {
      apiService
        .confirmLeadEmail(this.$route.params.token)
        .then(response => {
          this.registrationStatus = true
          this.loader = false
          console.log(response)
        })
        .catch(error => {
          console.log(error)
          this.registrationStatus = false
          this.loader = false
        })
    }
  }

}
</script>
<style scoped>
.container {
  background-color: #fff;
  padding: 0;
}
</style>
